import { useEffect, useMemo, useState } from "react"
import { PRESS_ACTION_QUERY } from "@/pages/api/fragments"
import useSWR from "swr"
import { createNestedArray } from "@/components/Press/MediaFeed"
import { fetcher } from "@/utils/utils"

const query = `
		query GetActionsData($first: IntType, $skip: IntType) {
		  pressMediaFeed {
			actions: _allReferencingPressActions(first: $first, skip: $skip, orderBy: date_DESC) {
			  date
			  ${PRESS_ACTION_QUERY}
			}
		  }
		}
`

export default function usePressActions(currPage = 1, itemsPerPage = 4, active = false, offset = 0, totalPages) {
	const length = useMemo(() => totalPages - offset, [totalPages, offset]) //how many pages can be fetched
	const [allActions, setAllActions] = useState(createNestedArray(length)) //container for all actions loaded
	const [fetchedPagesList, setFetchedPagesList] = useState([])
	const range = useMemo(
		() => ({
			//calculate range of actions to fetch
			first: itemsPerPage,
			skip: currPage * itemsPerPage - itemsPerPage,
		}),
		[currPage, itemsPerPage],
	)

	const requestBody = useMemo(() => {
		return {
			query,
			variables: {
				first: range.first,
				skip: range.skip,
			},
		}
	}, [range])

	const { data } = useSWR(
		//fetch pages only if is active and currPage wasn't fetched already
		active && !fetchedPagesList.includes(currPage) ? ["/api/getData", requestBody] : null,
		fetcher,
	)

	useEffect(() => {
		const newActions = data?.data?.pressMediaFeed?.actions || []
		if (newActions.length > 0) {
			//memo currPage being successfully fetched
			setFetchedPagesList((prev) => [...prev, currPage])

			//update actions accordingly
			setAllActions((prevActions) =>
				[...new Array(length)].map((_, index) => (index === currPage - offset - 1 ? newActions : prevActions[index])),
			)
		}
	}, [data, currPage, offset, length])

	return {
		actions: allActions,
		// isLoading,
		// error
	}
}
